import { AttributionWindow, ProductType } from '../api'
import { ITextInput } from '@ads/front-core/components/Form/TextInput'

type ProductConfigItem = {
  withDevices: boolean
  type: ITextInput['type']
  rateKeys: ('DEFAULT' | AttributionWindow)[]
}

export type ProductConfig = {
  productType: ProductType
} & ProductConfigItem

export const PRODUCTS_MIN_RATES: Partial<
  Record<ProductType, ProductConfigItem>
> = {
  UNIVERSAL_CPC: {
    withDevices: false,
    type: 'currency',
    rateKeys: ['DEFAULT'],
  },
  UNIVERSAL_CPM: {
    withDevices: false,
    type: 'currency',
    rateKeys: ['DEFAULT'],
  },
  UNIVERSAL_VCPM: {
    withDevices: false,
    type: 'currency',
    rateKeys: ['DEFAULT'],
  },
  DISPLAY_CPC: {
    withDevices: true,
    type: 'currency',
    rateKeys: ['DEFAULT'],
  },
  DISPLAY_CPC_NATIVE: {
    withDevices: true,
    type: 'currency',
    rateKeys: ['DEFAULT'],
  },
  DISPLAY_CPM: {
    withDevices: true,
    type: 'currency',
    rateKeys: ['DEFAULT'],
  },
  DISPLAY_VCPM: {
    withDevices: true,
    type: 'number',
    rateKeys: ['DEFAULT'],
  },
  DISPLAY_CPSC: {
    withDevices: false,
    type: 'currency',
    rateKeys: ['DEFAULT'],
  },
  FEED_CPSC: {
    withDevices: false,
    type: 'currency',
    rateKeys: ['DEFAULT'],
  },
  PROSPECTING: {
    withDevices: true,
    type: 'currency',
    rateKeys: ['DEFAULT'],
  },
  PROSPECTING_2: {
    withDevices: false,
    type: 'currency',
    rateKeys: ['DEFAULT'],
  },
  MAILING_PROSPECTING: {
    withDevices: false,
    type: 'currency',
    rateKeys: ['DEFAULT'],
  },
  MAILING_RETARGETING: {
    withDevices: false,
    type: 'currency',
    rateKeys: ['DEFAULT'],
  },
  MAILING_STATIC: {
    withDevices: false,
    type: 'currency',
    rateKeys: ['DEFAULT'],
  },
  MAILING_STATIC_OTHER: {
    withDevices: false,
    type: 'currency',
    rateKeys: ['DEFAULT'],
  },
  MAILING_STATIC_CPM: {
    withDevices: false,
    type: 'currency',
    rateKeys: ['DEFAULT'],
  },
  NATIVE_LINK_DIRECT: {
    withDevices: false,
    type: 'currency',
    rateKeys: ['DEFAULT'],
  },
  NATIVE_SG: {
    withDevices: false,
    type: 'currency',
    rateKeys: ['DEFAULT'],
  },
  START_AD: {
    withDevices: false,
    type: 'currency',
    rateKeys: ['DEFAULT'],
  },
  PAUSE_AD: {
    withDevices: false,
    type: 'currency',
    rateKeys: ['DEFAULT'],
  },
  PUBLISHERS_DISPLAY_CPC: {
    withDevices: true,
    type: 'currency',
    rateKeys: ['DEFAULT'],
  },
  PUBLISHERS_DISPLAY_CPM: {
    withDevices: true,
    type: 'number',
    rateKeys: ['DEFAULT'],
  },
  PUBLISHERS_DISPLAY_VCPM: {
    withDevices: true,
    type: 'number',
    rateKeys: ['DEFAULT'],
  },
  RETARGETING: {
    withDevices: false,
    type: 'number',
    rateKeys: ['LAST_CLICK_1D', 'LAST_CLICK', 'D2', 'D7', 'D14', 'D30'],
  },
  ROAS: {
    withDevices: false,
    type: 'number',
    rateKeys: ['LAST_CLICK_1D', 'LAST_CLICK', 'D2', 'D7', 'D14', 'D30'],
  },
  OUTSTREAM_VIDEO_CPM: {
    withDevices: false,
    type: 'currency',
    rateKeys: ['DEFAULT'],
  },
  OUTSTREAM_VIDEO_VCPM: {
    withDevices: false,
    type: 'number',
    rateKeys: ['DEFAULT'],
  },
}
